export default "__VITE_ASSET__BZOfOkVU__"